export default __webpack_public_path__ + "static/media/party-popper.0fbbbfa2.png";